import { AmrTableMarkdownItem } from './amr-table-markdown-item.js';
import { JsonBodyRemarkPlugin } from './markdown-plugins-utils.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/** Directive name used in markdown container blocks: `:::amr-table` */
export const AMR_TABLE_DIRECTIVE = 'amr-table';

/** Remark plugin definition for the `amr-table` container directive (`:::amr-table`). */
export const amrTableDirectiveDefinition: RemarkMarkdownDirectiveDefinition = {
	allowedAttributes: ['jsonData'],
	directive: JsonBodyRemarkPlugin(AMR_TABLE_DIRECTIVE),
	item: AmrTableMarkdownItem,
};
